


















import { debounceProcess } from "@/helpers/debounce";
import { useContactData } from "@/hooks/contact";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { LabelInValue } from "@/types";
import { ListContactDataDto } from "@interface/contact-data";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SelectInsurance extends Vue {
  @Prop({ required: false, type: Object })
  value!: LabelInValue;

  @Prop({ required: false, type: Boolean, default: false })
  disabled!: boolean;

  options: Option<ListContactDataDto>[] = [];
  loading = false;

  created(): void {
    this.onSearch = debounceProcess(this.onSearch);

    this.fetchOptions();
  }

  fetchOptions(params: RequestQueryParams = new RequestQueryParams()): void {
    const { findAllInsurance, toSupplierOptions } = useContactData();
    this.loading = true;
    findAllInsurance(params)
      .then(res => {
        this.options = toSupplierOptions(res.data);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onChange(e?: LabelInValue): void {
    this.$emit("input", e);
    this.$emit("change", e);
    this.$emit("update:meta", this.findOption(e));
  }

  onSearch(val = ""): void {
    const { filterBy } = useContactData();
    const params = new RequestQueryParams();
    params.search = filterBy({
      firstName: val,
      lastName: val,
    });

    this.fetchOptions(params);
  }

  findOption(value?: LabelInValue): Option<ListContactDataDto> | undefined {
    return this.options.find(e => value?.key === e.value);
  }
}
